import { useEffect } from "react";

import { notifications } from "@mantine/notifications";

export function useAsyncNotifications({
	isSuccess,
	isError,
	error,
	success,
}: {
	isSuccess: boolean;
	isError: boolean;
	error: Parameters<typeof notifications.show>[0];
	success?: Parameters<typeof notifications.show>[0];
}) {
	useEffect(() => {
		if (isSuccess && success) {
			notifications.show({ autoClose: 1000, ...success });
		}
	}, [isSuccess]);

	useEffect(() => {
		if (isError) {
			notifications.show({ autoClose: 2000, ...error });
		}
	}, [isError]);
}
